"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var hlineStyleFactory = function (type, vertical, bottomSpace, topSpace, leftSpace, rightSpace) {
    var styles = {};
    if (vertical) {
        styles.marginLeft = utils_1.toREMString(leftSpace);
        styles.marginRight = utils_1.toREMString(rightSpace);
        styles.borderRightStyle = type;
    }
    else {
        styles.marginTop = utils_1.toREMString(topSpace);
        styles.marginBottom = utils_1.toREMString(bottomSpace);
        styles.borderBottomStyle = type;
    }
    return styles;
};
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, _b = _a.bottomSpace, bottomSpace = _b === void 0 ? 3.6 : _b, _c = _a.topSpace, topSpace = _c === void 0 ? 3.6 : _c, _d = _a.leftSpace, leftSpace = _d === void 0 ? 3 : _d, _e = _a.rightSpace, rightSpace = _e === void 0 ? 3 : _e, vertical = _a.vertical, _f = _a.type, type = _f === void 0 ? "dashed" : _f, others = tslib_1.__rest(_a, ["theme", "className", "bottomSpace", "topSpace", "leftSpace", "rightSpace", "vertical", "type"]);
    var _g;
    return (React.createElement("div", tslib_1.__assign({}, others, { className: classnames_1.default(className, (_g = {},
            _g[theme.hline] = !vertical,
            _g[theme.vline] = vertical,
            _g)), style: hlineStyleFactory(type, vertical, bottomSpace, topSpace, leftSpace, rightSpace) })));
});
